import React from 'react'
import { Header } from 'components/Header'
import { Button, Flex } from '@workwhile/ui'
import { QueryStatus } from 'components/QueryStatus'
import { useBillRatesContextValue } from '../context/BillRatesProvider'
import { useBillRatesWorkflowsContextValue } from '../context/BillRatesWorkflowsProvider'

export const BillRatesHeader = () => {
  const { state, actions } = useBillRatesContextValue()
  const { createBillRateFlow } = useBillRatesWorkflowsContextValue()

  return (
    <Header
      title="Bill Rates"
      rightContent={
        <Flex alignItems="center" gap={2}>
          <QueryStatus
            dataUpdatedAt={state.dataUpdatedAt}
            isFetching={state.isFetching}
            refetch={actions.refetch}
            isError={state.isError}
            error={state.error}
          />
          <Button
            variant="primary"
            kind="medium"
            onClick={createBillRateFlow.open}
          >
            <Flex as="span" alignItems="center" style={{ gap: 8 }}>
              Create Bill Rate
            </Flex>
          </Button>
        </Flex>
      }
    />
  )
}
